export enum Options {
  PAGE = 'page',
  TOPBAR = 'top-bar',
  MENU = 'menu',
  SIDE_NAVIGATION = 'side-navigation',
  DND_MOVING_ITEM = 'dnd-moving-item',
  MOBILE_NAVIGATION = 'mobile-navigation',
  SIDE_NAVIGATION_BACKDROP = 'side-navigation-backdrop',
  MOBILE_ADD_BUTTON = 'mobile-add-button',
  DETAIL_COLUMN = 'detail-column',
  DIALOG = 'dialog',
  TOOLTIP = 'tooltip',
  // a modal raised from inside a popup — must cover the PopupMenu that spawned it, which
  // deliberately sits above DIALOG so selects inside ordinary dialogs still work
  POPUP_DIALOG = 'popup-dialog',
  BOTTOM_RIGHT_MESSAGE = 'bottom-right-message',
  IOS_BANNER = 'ios-banner',
}

const order = [
  Options.PAGE,
  Options.MENU,
  Options.TOPBAR,
  Options.SIDE_NAVIGATION_BACKDROP,
  Options.SIDE_NAVIGATION,
  Options.DND_MOVING_ITEM,
  Options.MOBILE_NAVIGATION,
  Options.MOBILE_ADD_BUTTON,
  Options.DETAIL_COLUMN,
  Options.IOS_BANNER,
  Options.DIALOG,
  Options.TOOLTIP,
  Options.POPUP_DIALOG,
  Options.BOTTOM_RIGHT_MESSAGE,
];

export function index(option: Options): number {
  return order.findIndex((value) => value === option);
}
